import { useEffect, useRef, useState } from 'react';

/**
 * Ticking resend-cooldown countdown, shared by ForgotPasswordPage (fixed 61s
 * per resend) and OtpLoginPage (escalating 30s/60s/120s per spec). `steps` is
 * consumed in order per successive `start()` call, clamped to the last entry
 * once exhausted — pass a single-element array for a fixed cooldown.
 */
export function useResendCooldown(steps: number[]) {
  const [countdown, setCountdown] = useState(0);
  const stepIndexRef = useRef(0);

  useEffect(() => {
    if (countdown <= 0) return;
    const id = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(id);
  }, [countdown]);

  const start = () => {
    const step = steps[Math.min(stepIndexRef.current, steps.length - 1)] ?? 0;
    stepIndexRef.current += 1;
    setCountdown(step);
  };

  const reset = () => {
    stepIndexRef.current = 0;
    setCountdown(0);
  };

  return { countdown, isCoolingDown: countdown > 0, start, reset };
}
